import React from 'react';

import cn from 'classnames';

import st from './SelectImage.module.sass';

interface SelectImageOption<Value extends string> {
  alt: string;
  id: Value;
  imageUrl: string;
}

interface SelectImageProps<Value extends string> {
  disabled: boolean;
  onChange: (value: Value) => void;
  options: SelectImageOption<Value>[];
  value: Value;
}

function SelectImage<Value extends string>({
  disabled,
  onChange,
  options,
  value,
}: SelectImageProps<Value>): React.JSX.Element {
  return (
    <div className={st.Root}>
      {options.map((option) => (
        <button
          className={cn(
            st.ImageButton,
            value === option.id && st.Selected,
            disabled && st.Disabled,
          )}
          data-testid={`SelectImage-${option.id}`}
          disabled={disabled}
          key={option.id}
          onClick={() => !disabled && onChange(option.id)}
          type="button"
        >
          <img
            alt={option.alt}
            className={st.Image}
            src={option.imageUrl}
          />
        </button>
      ))}
    </div>
  );
}

export { SelectImage };
